import React, { useEffect, useState, useRef } from "react";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  openPolicyModal,
  openProposal,
  resetFormState,
  setNumericValidError,
  setSelectValidError,
} from "../../../../slices/common/reducer";

import { Form, Button, OverlayTrigger, Popover } from "react-bootstrap";
import {
  changeActiveTabs,
  resetVariantModalState,
  setDetailsData,
  setDoctorCategory,
  setHandleManualPaymentModal,
  setOrderId,
  setProductAttributesData,
  setProductData,
  setProductVariantEdit,
  setProductVariantModalState,
} from "../../../../slices/orders/orderSlice";
import {
  createOrder,
  getAllCustomer,
  getAllProduct,
  getAllProductVariant,
  getFormRenderer,
  getRedirectUrl,
  readData,
  resendCertificatePolicy,
  resendInvoice,
  updateOrder,
  updateStatusOrder,
  updateSyncApplicationForm,
  updateSyncCertificate,
  updateSyncInvoice,
  uploadDocuments,
  getCkycStatus,
} from "../OrderService";
import { KYC_ALLOWED_OEM_IDS } from "../OrderUtils";
import useGeneratePaymentLink from "../Hook/useGeneratePaymentLink";
import RedirectUrlModal from "../Modal/RedirectUrlModal";
import KycModal from "../Modal/KycModal";
import Details from "./Details";
import Documents from "./Documents";
import Transactions from "./Transactions";
import Policy from "./Policy";
import EventLogs from "./EventLogs";
import ProductVariant from "./ProductVariant";
import {
  checkButtonAccess,
  customSelectStyles,
  getOrgId,
  getOrgType,
} from "../../../../Utils/CommonUtils";
import PolicyModal from "../Modal/PolicyModal";
import Product from "./Product";
import "../Order.scss";
import CreateDocument from "./CreateDocument";
import { showToast } from "../../../../common/Toaster/Toaster";
import ProposalModal from "../Modal/ProposalModal";
import OrderRestrictionModal from "../Modal/OrderRestrictionModal";
import useUpdateOrder from "../Hook/useUpdateOrder";
import useOrderDetails, { ORDER_DETAILS_QUERY_KEY } from "../Hook/useOrderDetails";

const SelectedOrders = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const tabs = useSelector((state) => state.order.selectedOrders.tab);
  const tabsEdit = useSelector((state) => state.order.selectedOrders.tabEdit);
  const activeTab = useSelector(
    (state) => state.order.selectedOrders.activeTabs
  );
  const modalShow = useSelector((state) => state.common.modalShow);
  const editMode = Boolean(id);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const storedUser = JSON.parse(localStorage.getItem("selectedUser")) || {};
  const storedOrgType = localStorage.getItem("organizationType");

  const isAdmin =
    selectedUser?.providerName?.toUpperCase() === "AGSA" ||
    selectedUser?.organization_type?.toUpperCase() === "AGSA" ||
    storedUser?.providerName?.toUpperCase() === "AGSA" ||
    storedUser?.organization_type?.toUpperCase() === "AGSA" ||
    storedOrgType?.toUpperCase() === "AGSA";
  // Editing attributes after payment is controlled by the EDIT_ATTRIBUTE module access
  const canEditPaidAttributes = checkButtonAccess
    ? checkButtonAccess("EDIT_ATTRIBUTE", "ORD_ORDS")
    : false;

  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );

  const isPaymentSuccess =
    detailsData?.status === "PAYMENT_SUCCESS" ||
    detailsData?.status === "COMPLETED";

  const canResendAccess = checkButtonAccess
    ? checkButtonAccess("RESEND_EMAIL", "ORD_ORDS")
    : true;

  const showEventTab = (isAdmin || canResendAccess) && canResendAccess && isPaymentSuccess;

  const rawSelectedTabs = editMode ? tabsEdit : tabs;
  const selectedTabs = rawSelectedTabs.filter(
    (tab) => tab.value !== "event" || showEventTab
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const invoiceFile = useSelector(
    (state) => state.order.selectedOrders.invoiceFile
  );
  const orderId = useSelector((state) => state.order.orderId);
  const certificateFile = useSelector(
    (state) => state.order.selectedOrders.certificateFile
  );
  const productVariant = useSelector(
    (state) => state.order.selectedOrders.productVariant
  );
  const navigator = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const policyModal = useSelector((state) => state.common.policyModalShow);
  const [isOrderCreated, setIsOrderCreated] = useState(false);
  const [restrictionError, setRestrictionError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const autoCheckingRef = useRef(false);
  const lastCheckedRef = useRef(0);
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  const editDetailsFieldJson = useSelector(
    (state) => state.order.selectedOrders.editDetailsFieldJson
  );
  const proposalShow = useSelector((state) => state.common.proposalShow);
  const orgType = getOrgType();
  const isAdminAccess =
   
    (selectedUser?.organization_type === "AGSA" ||
      orgType === "AGSA" ||
      localStorage.getItem("organizationType") === "AGSA") &&
    (checkButtonAccess
      ? checkButtonAccess("SYNC_DOC", "ORD_ORDS")
      : false);
  const header = useSelector((state) => state.header.dropdownData?.AG);
  const [newAgOrgId, setNewAgOrgId] = useState();
  const [kycModalOpen, setKycModalOpen] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const successToastShownRef = useRef(false);

  // TanStack React Query hook for Order Read API (Unique key: ["orderDetails", id])
  const { refetch: refetchOrderDetails } = useOrderDetails(id, {
    enabled: !!(editMode && id),
  });

  const handleCheckKycStatus = async () => {
    const memberId = detailsData.billing_member_id || detailsData.member_id || detailsData.customer_id;
    const orderId = detailsData.entityid;
    if (!memberId || !orderId) {
      showToast("Missing member ID or order ID", "error");
      return;
    }
    setCheckingStatus(true);
    try {
      const response = await getCkycStatus(memberId, orderId);
      const data = response.data;

      const finalStatus = data.final_status !== undefined && data.final_status !== null
        ? String(data.final_status)
        : data.member_ckyc?.final_status !== undefined && data.member_ckyc?.final_status !== null
          ? String(data.member_ckyc.final_status)
          : data.provider_response?.response?.finalStatus !== undefined && data.provider_response?.response?.finalStatus !== null
            ? String(data.provider_response.response.finalStatus)
            : "";

      if (finalStatus === "0" || data.kyc_status === "Failed") {
        showToast(data.ckyc_remarks || "KYC verification failed. Please try again.", "error");
        refetchOrderDetails();
      } else if (finalStatus === "1" || finalStatus === "3" || data.kyc_status === "Completed") {
        if (!successToastShownRef.current) {
          successToastShownRef.current = true;
          showToast("Verification successful!", "success");
        } else {
          showToast("Verification already completed.", "info");
        }
        refetchOrderDetails();
      } else {
        showToast("KYC verification is in progress.", "warning");
        refetchOrderDetails();
      }
    } catch (error) {
      console.error("CKYC status check failed:", error?.message);
      showToast(error.response?.data?.error_message || "Failed to fetch KYC status.", "error");
    } finally {
      setCheckingStatus(false);
    }
  };

  const renderKycBanner = () => {
    if (!editMode || !detailsData || !detailsData.entityid) return null;

    const { is_kyc, kyc_status, member_ckyc, can_retry, ckyc_remarks, show_kyc } = detailsData;

    const currentOemId = Number(
      detailsData?.oem_id ||
      formState?.oem_id ||
      detailsData?.insurance_company_id ||
      formState?.insurance_company_id
    );
    const isFgOrder = KYC_ALLOWED_OEM_IDS.includes(currentOemId);

    // Show the KYC banner only for FG OEM orders when the API sends show_kyc: true
    const isKycApplicable = isFgOrder && show_kyc === true;
    if (!isKycApplicable) return null;

    const currentStatus = String(kyc_status || member_ckyc?.kyc_status || "").trim();
    const norm = currentStatus.toLowerCase().replace(/[\s_-]+/g, "");

    const finalStatus = String(
      detailsData.final_status ?? member_ckyc?.final_status ?? ""
    );

    const isCompleted =
      is_kyc === true ||
      is_kyc === 1 ||
      is_kyc === "1" ||
      is_kyc === "true" ||
      ["completed", "verified", "kycverificationsuccessful", "success", "successful"].includes(norm) ||
      finalStatus === "1" ||
      finalStatus === "3";

    const isFailed =
      ["failed", "rejected", "kycverificationfailed", "error"].includes(norm) ||
      finalStatus === "0";

    // Three states only (formatKycStatus): completed -> no banner, failed, else pending.
    if (isCompleted) {
      return null;
    }

    if (isFailed) {
      return (
        <div className="alert alert-danger d-flex align-items-center justify-content-between rounded-3 border-0 shadow-sm p-3 mb-4 animate__animated animate__fadeIn" style={{ background: "linear-gradient(135deg, #f8d7da 0%, #f5c2c7 100%)", color: "#842029" }}>
          <div className="d-flex align-items-center gap-2">
            <span className="fs-5">✗</span>
            <div>
              <span className="fw-semibold d-block">KYC Verification Failed</span>
              {ckyc_remarks && <small className="d-block text-dark fw-medium mb-1">Remarks: {ckyc_remarks}</small>}
              <small className="d-block text-muted">The verification request was rejected. Please try again.</small>
            </div>
          </div>
          <div className="d-flex gap-2 align-items-center">
            {can_retry !== false && (
              <Button color="danger" size="sm" className="rounded-2 px-3 fw-semibold text-white shadow-sm" onClick={() => setKycModalOpen(true)}>
                Try Again
              </Button>
            )}
            <Button color="warning" size="sm" className="rounded-2 px-3 fw-semibold text-white shadow-sm" onClick={handleCheckKycStatus} disabled={checkingStatus}>
              {checkingStatus ? <Spinner size="sm" color="light" /> : "Check Status"}
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="alert alert-info d-flex align-items-center justify-content-between rounded-3 border-0 shadow-sm p-3 mb-4 animate__animated animate__fadeIn" style={{ background: "linear-gradient(135deg, #cff4fc 0%, #b6effb 100%)", color: "#055160" }}>
        <div className="d-flex align-items-center gap-2">
          <span className="fs-5">ℹ</span>
          <div>
            <span className="fw-semibold d-block">KYC Verification Pending</span>
            <small className="d-block">KYC verification is required to finalize this order.</small>
          </div>
        </div>
        <Button color="info" size="sm" className="rounded-2 px-3 fw-semibold text-white shadow-sm" onClick={() => setKycModalOpen(true)}>
          Complete KYC
        </Button>
      </div>
    );
  };

  useEffect(() => {
    if (formState?.ag_id && Array.isArray(header)) {
      const matchingId = header.find(
        (item) => item.entityid === formState.ag_id
      );
      if (matchingId) {
        setNewAgOrgId(matchingId.organizationid);
      }
    }
  }, [header, formState]);

  const ordersData = useSelector((state) => state.order.ordersData);

  useEffect(() => {
    if (activeTab === "event" && !showEventTab && editMode) {
      dispatch(changeActiveTabs("details"));
    }
  }, [activeTab, showEventTab, editMode, dispatch]);

  useEffect(() => {
    setCurrentIndex(selectedTabs.findIndex((tab) => tab.value === activeTab));
  }, [activeTab, selectedTabs]);

  useEffect(() => {
    dispatch(setProductVariantModalState({}));
    dispatch(setDoctorCategory({}));
    // dispatch(setProductVariantEdit({}));
  }, [formState.product_id, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(setProductAttributesData([]));
      dispatch(resetVariantModalState());
      dispatch(changeActiveTabs("details"));
      dispatch(setDetailsData({}));
      dispatch(setOrderId(""));
      dispatch(setHandleManualPaymentModal(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (editMode && id) {
      successToastShownRef.current = false;
      readData(id, "ODR");

      const inProgress =
        sessionStorage.getItem("ckyc_in_progress") === "true" ||
        localStorage.getItem("ckyc_in_progress") === "true";
      const stashedOrderId =
        sessionStorage.getItem("ckyc_order_id") ||
        localStorage.getItem("ckyc_order_id");
      const hasReturnedFromKyc = inProgress && String(stashedOrderId) === String(id);

      if (hasReturnedFromKyc) {
        const stashedMemberId = sessionStorage.getItem("ckyc_member_id") || localStorage.getItem("ckyc_member_id");
        const oId = stashedOrderId || id;

        sessionStorage.removeItem("ckyc_in_progress");
        sessionStorage.removeItem("ckyc_member_id");
        sessionStorage.removeItem("ckyc_order_id");
        localStorage.removeItem("ckyc_in_progress");
        localStorage.removeItem("ckyc_member_id");
        localStorage.removeItem("ckyc_order_id");

        const runPostKycStatusCheck = async () => {
          try {
            const mId = stashedMemberId || detailsData?.billing_member_id || detailsData?.member_id || detailsData?.customer_id;
            if (mId && oId) {
              const response = await getCkycStatus(mId, oId);
              const data = response?.data;
              const finalStatus = data?.final_status !== undefined && data?.final_status !== null
                ? String(data.final_status)
                : data?.member_ckyc?.final_status !== undefined && data?.member_ckyc?.final_status !== null
                  ? String(data.member_ckyc.final_status)
                  : data?.provider_response?.response?.finalStatus !== undefined && data?.provider_response?.response?.finalStatus !== null
                    ? String(data.provider_response.response.finalStatus)
                    : "";
              const kStatus = data?.kyc_status || data?.member_ckyc?.kyc_status || "";

              if (finalStatus === "1" || finalStatus === "3" || kStatus === "Completed") {
                if (!successToastShownRef.current) {
                  successToastShownRef.current = true;
                  showToast("Verification successful!", "success");
                }
              } else if (finalStatus === "0" || kStatus === "Failed") {
                showToast(data?.ckyc_remarks || "KYC verification failed. Please try again.", "error");
              }
            }
          } catch (e) {
            console.error("Error checking CKYC status on return", e);
          } finally {
            refetchOrderDetails();
          }
        };
        runPostKycStatusCheck();
      }
    }
  }, [editMode, id]);

  useEffect(() => {
    if (editMode && detailsData?.entityid) {
      const isCompleted =
        detailsData.is_kyc === true ||
        detailsData.kyc_status === "Completed" ||
        detailsData.final_status === "1" ||
        detailsData.final_status === "3";

      const wasReturning =
        sessionStorage.getItem("ckyc_in_progress") === "true" ||
        localStorage.getItem("ckyc_in_progress") === "true";

      if (wasReturning && isCompleted) {
        sessionStorage.removeItem("ckyc_in_progress");
        localStorage.removeItem("ckyc_in_progress");
        if (!successToastShownRef.current) {
          successToastShownRef.current = true;
          showToast("Verification successful!", "success");
        }
      }
    }
  }, [editMode, detailsData]);

  useEffect(() => {
    const handleFocus = () => {
      const { show_kyc, kyc_status, member_ckyc } = detailsData || {};
      const statusStr = String(kyc_status || member_ckyc?.kyc_status || "").trim();
      const norm = statusStr.toLowerCase().replace(/[\s_-]+/g, "");
      const isActivelyInProgress = [
        "uploaded",
        "underreview",
        "inprogress",
        "submitted",
        "processing",
        "initiated",
        "kycverificationinprogress",
      ].includes(norm);

      if (editMode && isActivelyInProgress && show_kyc === true) {
        const now = Date.now();
        if (now - lastCheckedRef.current < 5000) return; // Prevent calling more than once every 5 seconds
        if (autoCheckingRef.current) return; // Already running check, ignore duplicate focus triggers

        const memberId = detailsData.billing_member_id || detailsData.member_id || detailsData.customer_id;
        const orderId = detailsData.entityid;
        if (memberId && orderId) {
          autoCheckingRef.current = true;
          lastCheckedRef.current = now;
          getCkycStatus(memberId, orderId)
            .then((response) => {
              const data = response.data;
              const finalStatus = data.final_status !== undefined && data.final_status !== null
                ? String(data.final_status)
                : data.member_ckyc?.final_status !== undefined && data.member_ckyc?.final_status !== null
                  ? String(data.member_ckyc.final_status)
                  : data.provider_response?.response?.finalStatus !== undefined && data.provider_response?.response?.finalStatus !== null
                    ? String(data.provider_response.response.finalStatus)
                    : "";

              if (finalStatus === "0" || data.kyc_status === "Failed") {
                showToast(data.ckyc_remarks || "KYC verification failed. Please try again.", "error");
              } else if (finalStatus === "1" || finalStatus === "3" || data.kyc_status === "Completed") {
                if (!successToastShownRef.current) {
                  successToastShownRef.current = true;
                  showToast("Verification successful!", "success");
                }
              }
              refetchOrderDetails();
            })
            .catch((e) => console.error("Error auto checking CKYC on focus", e))
            .finally(() => {
              autoCheckingRef.current = false;
            });
        }
      }
    };
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [editMode, id, detailsData]);

  useEffect(() => {
    if (detailsData.product_id && newAgOrgId) {
      getFormRenderer(detailsData.product_id, newAgOrgId);
    }
  }, [detailsData.product_id, newAgOrgId]);

  // useEffect(() => {
  //   if (id && productVariantModalState.qualification) {
  //     console.log("Qualification updated:", productVariantModalState);
  //     getDoctorCategory(
  //       detailsData.product_id,
  //       productVariantModalState.qualification
  //     );
  //   }
  // }, [detailsData?.product_id, productVariantModalState?.qualification]);

  const breadcrumbItems = editMode
    ? [
      { title: "Orders", link: "/order/orders" },
      { title: `${detailsData.code}`, link: "/order/orders" },
    ]
    : [
      { title: "Orders", link: "" },
      { title: "Orders", link: "/order/orders" },
      { title: "New Order", link: "/order/orders/create" },
    ];

  const handleSendLink = async () => {
    // getRedirectUrl(id);
    dispatch(openModal(true));
    if (id) {
      // try {
      await getRedirectUrl(id);
      // dispatch(openModal(true));
      // } catch (error) {
      //   console.error("Error fetching redirect URL:", error);
      // }
    }
  };

  const { mutate: generatePaymentLink, isPending: isPaymentLinkLoading } =
    useGeneratePaymentLink();

  const handlePaymentLink = () => {
    const entityId = detailsData.entityid || id;
    if (!entityId || isPaymentLinkLoading) return;
    generatePaymentLink(entityId);
  };

  const handleOpenProposal = async () => {
    // getRedirectUrl(id);
    dispatch(openProposal(true));
  };

  const [showPopover, setShowPopover] = useState(false);
  const [showSyncPopover, setShowSyncPopover] = useState(false);

  const handleStatusChange = async (selectedOption) => {
    setShowPopover(false);
    if (selectedOption.value === "certificate") {
      resendCertificatePolicy(detailsData.entityid);
    } else if (selectedOption.value === "invoice") {
      resendInvoice(detailsData.entityid);
    }
  };

  const handleSyncOptionClick = async (type) => {
    setShowSyncPopover(false);
    if (!detailsData.entityid) return;
    if (type === "invoice") {
      updateSyncInvoice(detailsData.entityid);
    } else if (type === "certificate") {
      updateSyncCertificate(detailsData.entityid);
    } else if (type === "application_form") {
      updateSyncApplicationForm(detailsData.entityid);
    }
  };

  const handleCloseProposal = async () => {
    dispatch(openProposal(false));
  };

  const handleFinish = async () => {
    if (currentIndex === selectedTabs.length - 1) {
      if (isSubmittingRef.current) return;
      // Validate if required attributes are selected
      if (
        !productVariantModalState ||
        !Object.keys(productVariantModalState).length
      ) {
        showToast(
          "Please select the required attributes before proceeding.",
          "error"
        );
        return;
      }
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      try {
        await createOrder(
          formState,
          productVariantModalState.finalPremium,
          productVariantModalState.coverAmount,
          productVariantModalState.variant,
          "ODR",
          navigator
        );

        setIsOrderCreated(true);
        dispatch(changeActiveTabs("details"));
        dispatch(openModal(true));
      } catch (error) {
        console.error("Error creating order:", error);
        const errCode = error.response?.data?.error_code;
        if (['ERR_022', 'ERR_023', 'ERR_024', 'ERR_025'].includes(errCode)) {
          setRestrictionError(error.response.data);
        }
      } finally {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
      }
    } else {
      if (activeTab === "product_variant") {
        if (!Object.keys(productVariantModalState).length) {
          showToast(
            "Please fill out the Product Attributes form before proceeding.",
            "error"
          );
          return;
        }
      }

      if (
        formState.status &&
        formState.customer_id &&
        formState.order_type &&
        formState.ag_id &&
        formState.product_type &&
        formState.product_id
      ) {
        dispatch(setSelectValidError(false));
        dispatch(setNumericValidError(false));
        const nextTab = selectedTabs[currentIndex + 1].value;
        dispatch(changeActiveTabs(nextTab));
      } else {
        dispatch(setSelectValidError(true));
        dispatch(setNumericValidError(true));
        showToast(
          "Please fill all required fields before proceeding.",
          "error"
        );
      }
    }
  };

  // const updateOrderStatus = () => {
  //   uploadDocuments(
  //     detailsData.entityid,
  //     "ODR",
  //     detailsData.entityid,
  //     formState,
  //     productVariantModalState.variant
  //   );
  // };
  const updateOrderMutation = useUpdateOrder(id);

  const updateOrderStatus = () => {
    const variantState = productVariantModalState.variant
      ? productVariantModalState.variant
      : productVariantModalState;
    const currentState = productVariantModalState.variant
      ? productVariantModalState.variant
      : productVariantModalState;

    updateOrderMutation.mutate({
      entityid: detailsData.entityid,
      entitytype: "ODR",
      formState,
      variantState,
      currentState,
      finalPremium: productVariantModalState.finalPremium,
      coverAmount: productVariantModalState.coverAmount,
      orderType: detailsData.order_type,
    });
  };

  // useEffect(() => {
  //   if (!editMode) return;

  //   // if (formState.customer_id) {
  //   //   handleOrderUpdate();
  //   // } else {
  //   updateStatusOrder(
  //     detailsData.entityid,
  //     "ODR",
  //     detailsData.entityid,
  //     formState.status
  //   );
  //   // }
  // }, [formState.customer_id, formState.status, editMode, detailsData]);
  // const [originalState, setOriginalState] = useState({});

  const handleOrderUpdate = () => {
    return updateOrder(detailsData.entityid, formState.customer_id);
  };
  const handleStatusUpdate = () => {
    updateStatusOrder("ODR", detailsData.entityid, {
      status: formState.status,
    });
  };

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />

        <Card>
          <CardHeader>
            <SelectedTab
              tabs={selectedTabs}
              activeTab={activeTab}
              changeActiveTab={(tab) => dispatch(changeActiveTabs(tab))}
            // editMode={editMode}
            // preventNavigationTabs={["product_variant", "create_documents"]}
            />
          </CardHeader>
          <CardBody className="order-details">
            {renderKycBanner()}
            <div className="selected-tab-bottom-content">
              {activeTab === "details" && <Details />}
              {activeTab === "product_variant" && <ProductVariant />}
              {activeTab === "product" && <Product />}
              {/* {activeTab === "create_documents" && <CreateDocument />} */}
              {/* {activeTab === "documents" && <Documents />} */}
              {editMode && activeTab === "transactions" && <Transactions />}
              {editMode && activeTab === "documents" && <Documents />}
              {editMode && activeTab === "Policy_detail" && <Policy />}
              {editMode && activeTab === "event" && showEventTab && <EventLogs />}
            </div>
            <div className="d-flex justify-content-end mt-4 footer-buttons">
              {editMode &&
                !(
                  (detailsData.Policy_detail &&
                    detailsData.Policy_detail.length > 0) ||
                  detailsData.status === "CANCELLED"
                ) &&
                (checkButtonAccess
                  ? checkButtonAccess("SEND_LINK", "ORD_ORDS")
                  : true) && (
                  <Button
                    className="primary-outline me-2"
                    // disabled={!editMode}
                    onClick={handleSendLink}
                  >
                    Send Link
                  </Button>
                )}
              {editMode &&
                !(
                  (detailsData.Policy_detail &&
                    detailsData.Policy_detail.length > 0) ||
                  detailsData.status === "CANCELLED"
                ) &&
                (checkButtonAccess
                  ? checkButtonAccess("SEND_LINK", "ORD_ORDS")
                  : true) && (
                  <Button
                    className="primary-outline me-2"
                    disabled={isPaymentLinkLoading}
                    onClick={handlePaymentLink}
                  >
                    {isPaymentLinkLoading ? "Please wait..." : "Payment Link"}
                  </Button>
                )}
              {/* {!detailsData.Policy_detail && ( */}
              {editMode &&
                (checkButtonAccess
                  ? checkButtonAccess("VIEW", "ORD_PRF")
                  : true) && (
                  <Button
                    className="primary-outline me-2"
                    onClick={handleOpenProposal}
                  >
                    Proposal Form
                  </Button>
                )}
              {/* )} */}

              {editMode && isAdminAccess && (
                <OverlayTrigger
                  trigger="click"
                  placement="top"
                  show={showSyncPopover}
                  onToggle={() => setShowSyncPopover(!showSyncPopover)}
                  overlay={
                    <Popover id="sync-document-popover">
                      <Popover.Body>
                        <div
                          className="popover-item"
                          onClick={() => handleSyncOptionClick("invoice")}
                        >
                          Invoice Update
                        </div>
                        <div
                          className="popover-item"
                          onClick={() => handleSyncOptionClick("certificate")}
                        >
                          Certificate Update
                        </div>
                        <div
                          className="popover-item"
                          onClick={() => handleSyncOptionClick("application_form")}
                        >
                          Application Form Update
                        </div>
                      </Popover.Body>
                    </Popover>
                  }
                  rootClose
                >
                  <Button className="primary-outline me-2">Sync Document</Button>
                </OverlayTrigger>
              )}

              {detailsData.Policy_detail &&
                detailsData.Policy_detail.length > 0 &&
                editMode &&
                (checkButtonAccess
                  ? checkButtonAccess("RESEND_EMAIL", "ORD_ORDS")
                  : true) && (
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    show={showPopover}
                    onToggle={() => setShowPopover(!showPopover)}
                    overlay={
                      <Popover id="resend-popover">
                        <Popover.Body>
                          <div
                            className="popover-item"
                            onClick={() =>
                              handleStatusChange({ value: "invoice" })
                            }
                          >
                            Invoice
                          </div>
                          <div
                            className="popover-item"
                            onClick={() =>
                              handleStatusChange({ value: "certificate" })
                            }
                          >
                            Certificate & Policy
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                  >
                    <Button className="me-2">Resend</Button>
                  </OverlayTrigger>
                )}

              {editMode &&
                currentIndex === 0 &&
                detailsData.status !== "COMPLETED" &&
                detailsData.status !== "PAYMENT_SUCCESS" &&
                (checkButtonAccess
                  ? checkButtonAccess("UPDATE_ORDER", "ORD_ORDS")
                  : true) && (
                  <div className="update-btn">
                    {/* <Button
                      onClick={() => {
                        if (formState.status !== detailsData.status) {
                          handleStatusUpdate();
                        }

                        if (formState.customer_id !== detailsData.customer_id) {
                          handleOrderUpdate();
                        }
                      }}
                    >
                      Update Order
                    </Button> */}
                    <Button
                      onClick={async () => {
                        if (
                          formState.customer_id !== detailsData.customer_id
                        ) {
                          await handleOrderUpdate();
                        }
                        if (formState.status !== detailsData.status) {
                          await handleStatusUpdate();
                        }
                      }}
                    >
                      Update Order
                    </Button>
                  </div>
                )}
              {editMode &&
                currentIndex === 1 &&
                (canEditPaidAttributes ||
                  (!isPaymentSuccess && !detailsData.Policy_detail?.length)) &&
                detailsData.status !== "CANCELLED" &&
                (checkButtonAccess
                  ? checkButtonAccess("EDIT", "ORD_ORDS")
                  : true) && (
                  <div className="update-btn">
                    <Button
                      disabled={updateOrderMutation.isPending}
                      onClick={updateOrderStatus}
                    >
                      {updateOrderMutation.isPending ? "Updating..." : "Update"}
                    </Button>
                  </div>
                )}

              {!editMode && (
                <Button
                  onClick={handleFinish}
                  disabled={
                    isSubmitting ||
                    (currentIndex === selectedTabs.length - 1
                      ? false
                      : currentIndex === 0 && activeTab !== "details")
                  }
                >
                  {isSubmitting && currentIndex === selectedTabs.length - 1 ? "Creating..." : "Save"}
                </Button>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
      {modalShow && <RedirectUrlModal />}
      {policyModal && <PolicyModal />}
      {proposalShow && <ProposalModal />}
      <OrderRestrictionModal
        show={!!restrictionError}
        handleClose={() => setRestrictionError(null)}
        errorData={restrictionError}
      />
      {kycModalOpen && (
        <KycModal
          isOpen={kycModalOpen}
          toggle={() => setKycModalOpen(!kycModalOpen)}
          orderId={detailsData.entityid}
          memberId={detailsData.billing_member_id || detailsData.member_id || detailsData.customer_id}
          detailsData={detailsData}
          onSuccess={() => refetchOrderDetails()}
        />
      )}
    </>
  );
};

export default SelectedOrders;

